import { lazy, Suspense } from "react";

/**
 * Main App Component (JS SDK)
 * Conditionally loads DevScreenManager or ProdScreenManager based on environment
 * Uses React.lazy() for lazy loading to enable code splitting
 */

// Conditionally lazy-load the appropriate screen manager
const ScreenManager = lazy(() => {
  if (import.meta.env.DEV) {
    return import("@/screens/login");
  } else {
    return import("./ProdScreenManager");
  }
});

export default function App() {
  return (
    <Suspense fallback={null}>
      <ScreenManager />
    </Suspense>
  );
}
